var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfflineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:red;stroke:#e80f0f;}.b{stroke:none;}.c{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 5,
    cy: 5,
    r: 4.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineIcon);
export default __webpack_public_path__ + "static/media/offline_icon.a5fdca9d3f8ab0465a40a2eb64ba2363.svg";
export { ForwardRef as ReactComponent };